
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 36.39 60.71\" id=\"icon-footer-lockpad\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M17.82,0C2.39,0,0,9.84,0,12.89v5.61c0,0.02,0,0.04,0.01,0.06c0.02,0.89,0.73,1.63,1.59,1.63h11.37\r\n\tc0.86,0,1.57-0.74,1.59-1.63c0.01-0.02,0.01-0.04,0.01-0.06v-5.61c0-1.8,1.45-3.26,3.25-3.26c1.79,0,3.24,1.46,3.24,3.26v11H1.6\r\n\tc-0.88,0-1.6,0.77-1.6,1.65v22.29c0,3.26,2.39,12.88,17.82,12.88c15.42,0,18.57-9.77,18.57-12.88V12.89C36.39,9.84,33.24,0,17.82,0z\r\n\t M20.26,42.73v5.99c0,1.35-1.09,2.44-2.44,2.44c-1.35,0-2.45-1.09-2.45-2.44v-5.99c-2.13-0.94-3.63-3.07-3.63-5.56\r\n\tc0-3.35,2.72-6.07,6.08-6.07c3.35,0,6.06,2.72,6.06,6.07C23.88,39.66,22.39,41.79,20.26,42.73z\"/> </symbol>";
module.exports = sprite.add(image, "icon-footer-lockpad");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/footer-lockpad.svg
 ** module id = 179
 ** module chunks = 24
 **/